import RequestError from './HttpError';
const stringifyMap = (map) => Object.entries(map)
    .map(([key, value]) => [key, `${value}`])
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
export default class HttpClient {
    constructor(apiUri, defaultHeaders = {}, altfetch) {
        this.apiUri = apiUri;
        this.defaultHeaders = defaultHeaders;
        this.altfetch = altfetch;
    }
    async get(path, query = {}, headers = {}) {
        const headersExtended = {
            Accept: 'application/json; charset=utf-8',
            ...headers,
        };
        return this.fetch('GET', path, query, headersExtended);
    }
    async post(path, body, query = {}, headers = {}) {
        const headersExtended = {
            'Content-Type': 'application/json; charset=utf-8',
            ...headers,
        };
        return this.fetch('POST', path, query, headersExtended, body);
    }
    async fetch(method, path, query = {}, headers = {}, body) {
        var _a;
        const params = new URLSearchParams(Object.entries(query).map(([key, value]) => [key, value.toString()]));
        const qs = params.toString();
        const qsPrefixed = qs ? `?${qs}` : '';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const afetch = ((_a = window[this.altfetch]) !== null && _a !== void 0 ? _a : fetch);
        const response = await afetch(`${this.apiUri}${path}${qsPrefixed}`, {
            method,
            headers: stringifyMap({
                ...this.defaultHeaders,
                ...headers,
            }),
            mode: 'cors',
            credentials: 'same-origin',
            ...(body ? { body: JSON.stringify(body) } : {}),
        });
        if (!response.ok) {
            const { status, statusText } = response;
            const errorBody = await response.json();
            throw new RequestError(status, statusText, errorBody);
        }
        return method === 'GET' ? response.json() : undefined;
    }
}
//# sourceMappingURL=HttpClient.js.map